export enum SMTMealType {
  Meal = 'MEAL',
  Snack = 'SNACK',
}
